import TaskManagerEditDto from './TaskManagerEditDto';

export class LabMeasurementReaderTaskEditDto extends TaskManagerEditDto {

	constructor() {
		super();

		/** @type {boolean} */
		this.duplicateLastValueIfMissing = null;

		/** @type {boolean} */
		this.deleteTimeFromTs = null;

		/** @type {boolean} */
		this.deleteFromOutput = null;

		/** @type {boolean} */
		this.sortComponents = null;

		/** @type {number} */
		this.unitOptimizer = null;

		/** @type {boolean} */
		this.imputeNansWithZero = null;
	}

	/**
	 * @typedef {Object} _LabMeasurementReaderTaskEditDtoProps
	 * @property {boolean} duplicateLastValueIfMissing
	 * @property {boolean} deleteTimeFromTs
	 * @property {boolean} deleteFromOutput
	 * @property {boolean} sortComponents
	 * @property {number} unitOptimizer
	 * @property {number} imputeNansWithZero
	 *
	 * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _LabMeasurementReaderTaskEditDtoProps} LabMeasurementReaderTaskEditDtoProps
	 */
	/**
	 *
	 * @param {LabMeasurementReaderTaskEditDtoProps} props
	 * @returns {LabMeasurementReaderTaskEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.duplicateLastValueIfMissing = props.duplicateLastValueIfMissing;
		this.deleteTimeFromTs = props.deleteTimeFromTs;
		this.deleteFromOutput = props.deleteFromOutput;
		this.sortComponents = props.sortComponents;
		this.unitOptimizer = props.unitOptimizer;
		this.imputeNansWithZero = props.imputeNansWithZero;

		return this;
	}
}

export default LabMeasurementReaderTaskEditDto;